























































































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {FraudCase} from "@/model/fraud-case";
import {fraudCaseService, FraudCaseType} from "@/services/fraud-case";
import alertService from "@/services/alert";

@Component
export default class FraudCaseDetails extends Vue {

  @Prop()
  fraudCase!: FraudCase

  @Prop()
  complete!: boolean

  completeFraudCase: FraudCase = new FraudCase()

  tab: any = {};
  tabs: { name: string; type: FraudCaseType;content: any[] }[] = [];

  pardonDialog = false;
  newFraudCaseItemDialog = false;

  whyPardoned = '';

  itemToUpdate: any = {};
  itemToCreate: any = {};



  async mounted() {
    if(this.complete) {
      this.completeFraudCase = this.fraudCase;
    } else {
      this.completeFraudCase = await fraudCaseService.getFraudCaseById(this.fraudCase.id);
    }

    this.tabs = [];
    this.tabs.push({
      name: `Msisdns(${this.completeFraudCase.msisdns.length})`,
      type: FraudCaseType.MSISDN,
      content: this.completeFraudCase.msisdns.map( i  => {
        (i as any).value = i.msisdn;
        return i;
      })
    });
    this.tabs.push({
      name: `Credit Cards(${this.completeFraudCase.creditCards.length})`,
      type: FraudCaseType.CREDIT_CARD,
      content: this.completeFraudCase.creditCards.map( i  => {
        (i as any).value = i.creditCardToken;
        return i;
      })
    });
    this.tabs.push({
      name: `Users(${this.completeFraudCase.users.length})`,
      type: FraudCaseType.USER,
      content: this.completeFraudCase.users.map( i  => {
        (i as any).value = i.userId;
        return i;
      })
    });
    this.tabs.push({
      name: `Paypals(${this.completeFraudCase.paypalPayers.length})`,
      type: FraudCaseType.PAYPAL,
      content: this.completeFraudCase.paypalPayers.map( i  => {
        (i as any).value = i.paypalPayerId
        return i;
      })
    });
    this.tab = this.tabs[0];
  }

  copyToClipboard(value: string) {
    navigator.clipboard.writeText(value).then( () => {
      alertService.success(`${value} copied to clipboard`)
    }).catch(reason => alertService.error(`${reason} error copying to clipboard`));
  }

  updatePardonStatus(item: any, type: FraudCaseType) {
    this.itemToUpdate = item;
    this.itemToUpdate.type = type;
    this.pardonDialog = true;
    // if(item.pardoned) {
    //
    // } else {
    //   fraudCaseService.updatePardoned(
    //     item.id,
    //     item.value,
    //     type,
    //     item.pardoned,
    //     '')
    //     .then( success => {
    //     alertService.success(`${item.value} was blacklisted`);
    //     this.pardonDialog = false
    //   })
    //     .catch( error => {
    //       alertService.error('There was an error when updating the entry');
    //       this.pardonDialog = false;
    //     })
    // }
  }

  cancelUpdate() {
    this.pardonDialog = false;
    this.itemToUpdate = {};
    this.whyPardoned = '';
  }

  doUpdate() {
    this.itemToUpdate.whyPardoned = this.whyPardoned;
    fraudCaseService.updatePardoned(
      this.itemToUpdate.id,
      this.itemToUpdate.value,
      this.itemToUpdate.type,
      this.itemToUpdate.pardoned,
      this.itemToUpdate.whyPardoned)
      .then( success => {
        alertService.success(`${this.itemToUpdate.value} was pardoned`);
        this.pardonDialog = false
        this.itemToUpdate = {}
      })
      .catch( error => {
        alertService.error('There was an error when updating the entry');
        this.pardonDialog = false;
        this.itemToUpdate = {};
      })
  }

  cancelCreate() {
    this.newFraudCaseItemDialog = false;
    this.itemToCreate = {};
    this.whyPardoned = '';
  }

  doCreate() {
    fraudCaseService.addFraudCaseItem(
      this.completeFraudCase.id,
      this.itemToCreate.value,
      this.itemToCreate.type,
      this.itemToCreate.pardoned,
      this.itemToCreate.whyAdded,
      this.itemToCreate.whyPardoned)
      .then( success => {
        alertService.success(`${this.itemToCreate.value} was added`);
        this.newFraudCaseItemDialog = false
        this.itemToUpdate = {}
      })
      .catch( error => {
        alertService.error('There was an error when creating the entry');
        this.newFraudCaseItemDialog = false;
        this.itemToCreate = {}
      })
  }
}
